/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Livro {
  constructor () {
    this.livro_id = uuidV4()
    this.texto = ''
    this.imagens = []
  }
}
